import { getCookie, checkLocalStorage } from ".";
import setPurposesPositive from "../consent_string/set_purposes_positive";
import setPurposesNegative from "../consent_string/set_purposes_negative";
import { boundSetIsNotInitital } from "../../redux/actions/is_initial";
import deleteCookie from "./delete_cookie";
import removeFromLocalStorage from "./remove_from_localstorage";

const checkOldCookie = (cookieName = 'privacyPolicyS') => {
    let value = getCookie(cookieName) || checkLocalStorage(cookieName);

    if (value === null) { return value }

    value = value.split('.')[0].slice(1, value.length);
    
    boundSetIsNotInitital();

    if (value === '00000') { setPurposesNegative() }

    if (value === '11111') { setPurposesPositive() }

    deleteCookie(cookieName);
    removeFromLocalStorage(cookieName);
    return true;
};

export default checkOldCookie;